import { AfterViewChecked, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxHtmlEditorComponent, DxTextBoxComponent } from 'devextreme-angular';
import { StylingModeEditor } from '../../../base/src/abcEditor/abcEditor';
export class EditorToolbarItem {
  formatName: string;
  formatValues: Array<string | number | boolean> | null;
}

@Component({
    selector: 'test-app-devExEditor',
    template: `
    <div (mouseover)="mouseOver($event)" (mouseleave)="mouseLeave($event)" fxFill>
      @if (placeholder && !showToolbar) {
        <span
        [ngClass]="
          stylingMode == 'filled'
            ? rtlEnabled
              ? 'labelHtmlEditorFilledRtl'
              : 'labelHtmlEditorFilled'
            : rtlEnabled
            ? 'labelHtmlEditorRtl'
            : 'labelHtmlEditor'
        "
          >{{ placeholder }}</span
          >
        }
        @if (!showToolbar) {
          <span
            class="dx-icon-edit"
            (click)="onTextEdit(value)"
            [ngStyle]="{ display: displayEdit ? 'block' : 'none' }"
            [ngClass]="rtlEnabled ? 'editRtl' : 'edit'"
          ></span>
        }
        <dx-html-editor
          #devExEditor
          id="{{ id }}"
          [height]="height"
          [width]="width"
          [visible]="visible"
          [disabled]="disabled"
          [activeStateEnabled]="activeStateEnabled"
          [validationMessageMode]="validationMessageMode"
          [validationStatus]="validationStatus"
          [value]="_value"
          [validationError]="validationError"
          [validationError]="validationError"
          [validationErrors]="validationErrors"
          [readOnly]="readOnly"
          [rtlEnabled]="rtlEnabled"
          [tabIndex]="tabIndex"
          [focusStateEnabled]="focusStateEnabled"
          [hoverStateEnabled]="hoverStateEnabled"
          [isValid]="isValid"
          [stylingMode]="stylingMode"
          [name]="name"
          [class]="class"
          (onValueChanged)="valueChange($event)"
          >
          @if (showToolbar) {
            <dxo-html-editor-toolbar [multiline]="true">
              @if (saveIcon) {
                <dxi-html-editor-item [options]="toolbarSaveOptions" name="save"></dxi-html-editor-item>
              }
              @for (t of toolbarItems; track t) {
                <dxi-html-editor-item [name]="t.formatName" [acceptedValues]="t.formatValues"> </dxi-html-editor-item>
              }
              @if (identifier) {
                <dxi-html-editor-item formatName="separator"></dxi-html-editor-item>
              }
              @if (identifier) {
                <dxi-html-editor-item class="identifierInputStyle">
                  <span style="margin: auto; padding-right: 5px;">Kennung:</span>
                  <dx-text-box
                    #dxTextBox
                    value="{{ identifier }}"
                    showClearButton="true"
                    mode="text"
                    (onValueChanged)="identifierChanged($event)"
                    (onFocusOut)="setDefaultIdentifier()"
                    >
                  </dx-text-box>
                </dxi-html-editor-item>
              }
            </dxo-html-editor-toolbar>
          }
        </dx-html-editor>
      </div>
    `,
    styleUrls: ['./devExEditor.component.scss'],
    standalone: false
})
export class DevExEditorComponent implements OnInit, AfterViewChecked {
  @ViewChild('devExEditor', { static: true }) devExEditor: DxHtmlEditorComponent;
  @ViewChild('dxTextBox') dxTextBox: DxTextBoxComponent;
  @Input() id: string;
  @Input() height: string | number;
  @Input() width: string | number;
  @Input() visible: boolean = true;
  @Input() valueType: string = 'html';
  @Input() disabled: boolean;
  @Input() activeStateEnabled: boolean;
  @Input() focusStateEnabled: boolean;
  @Input() hoverStateEnabled: boolean;
  @Input() isValid: boolean = true;
  @Input() name: string = '';
  @Input() placeholder: string;
  @Input() stylingMode: StylingModeEditor;
  @Input() readOnly: boolean;
  @Input() rtlEnabled: boolean;
  @Input() tabIndex: number;
  @Input() validationError: string;
  @Input() validationErrors: string;
  @Input() validationMessageMode: string;
  @Input() validationStatus: string;
  @Input() set value(data: string) {
    this._value = this.viewChecked ? data : this.configureLinks(this.prepareInnerLinks(data));
  }
  @Input() displayEdit: boolean = false;
  @Input() displayIconEdit: boolean = false;
  @Input() showToolbar: boolean;
  @Input() saveIcon: boolean = false;
  @Input() class: string;
  @Input() filterToolbarItems: (items: EditorToolbarItem[]) => EditorToolbarItem[];
  @Output() onValueChanged = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onSaveClick: EventEmitter<any> = new EventEmitter();

  public identifier: string;
  private _identifier: string = '';
  private isFocusedOut = false;
  private viewChecked = false;
  public _value = '';

  toolbarSaveOptions: any = {
    onClick: (e) => this.onSaveClick.emit(e.event),
  };

  toolbarItems: EditorToolbarItem[];

  constructor() {}

  ngOnInit() {
    this.initToolbarItems();
  }

  ngAfterViewChecked(): void {
    this.viewChecked = true;
  }

  setText(val: string): void {
    this.devExEditor.writeValue(val);
  }

  getText(): string {
    return this.devExEditor.value;
  }

  getPlainText(): string {
    const val = this.devExEditor.value;
    const divElement: HTMLDivElement = document.createElement('div');
    divElement.innerHTML = val;
    const plainText = divElement.textContent;
    return plainText;
  }

  getIdentifier(): string {
    return this._identifier;
  }

  setDefaultIdentifier(): void {
    this.isFocusedOut = true;
    if (this._identifier == '') {
      this._identifier = 'Standard';
      this.dxTextBox.value = 'Standard';
      this.isFocusedOut = false;
    }
  }

  identifierChanged(event): void {
    this._identifier = event.value;
  }

  valueChange(event): void {
    this.value = event.value;
    this.onValueChanged.emit(event);
  }

  onTextEdit(e) {
    this.onEdit.emit(e);
  }
  mouseOver(e) {
    if (this.displayIconEdit === true) this.displayEdit = true;
  }
  mouseLeave(e) {
    if (this.displayIconEdit === true) this.displayEdit = false;
  }
  initToolbarItems() {
    this.toolbarItems = [
      { formatName: 'undo', formatValues: null } as EditorToolbarItem,
      { formatName: 'redo', formatValues: null } as EditorToolbarItem,
      { formatName: 'separator', formatValues: null } as EditorToolbarItem,
      {
        formatName: 'size',
        formatValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
      } as EditorToolbarItem,
      {
        formatName: 'font',
        formatValues: [
          'Arial',
          'Courier New',
          'Georgia',
          'Impact',
          'Lucida Console',
          'Tahoma',
          'Times New Roman',
          'Verdana',
        ],
      } as EditorToolbarItem,
      { formatName: 'separator', formatValues: null } as EditorToolbarItem,
      { formatName: 'bold', formatValues: null } as EditorToolbarItem,
      { formatName: 'italic', formatValues: null } as EditorToolbarItem,
      { formatName: 'strike', formatValues: null } as EditorToolbarItem,
      { formatName: 'underline', formatValues: null } as EditorToolbarItem,
      { formatName: 'separator', formatValues: null } as EditorToolbarItem,
      { formatName: 'alignLeft', formatValues: null } as EditorToolbarItem,
      { formatName: 'alignCenter', formatValues: null } as EditorToolbarItem,
      { formatName: 'alignRight', formatValues: null } as EditorToolbarItem,
      { formatName: 'alignJustify', formatValues: null } as EditorToolbarItem,
      { formatName: 'separator', formatValues: null } as EditorToolbarItem,
      { formatName: 'orderedList', formatValues: null } as EditorToolbarItem,
      { formatName: 'bulletList', formatValues: null } as EditorToolbarItem,
      { formatName: 'separator', formatValues: null } as EditorToolbarItem,
      { formatName: 'header', formatValues: [false, 1, 2, 3, 4, 5] } as EditorToolbarItem,
      { formatName: 'separator', formatValues: null } as EditorToolbarItem,
      { formatName: 'color', formatValues: null } as EditorToolbarItem,
      { formatName: 'background', formatValues: null } as EditorToolbarItem,
      { formatName: 'separator', formatValues: null } as EditorToolbarItem,
      { formatName: 'link', formatValues: null } as EditorToolbarItem,
      { formatName: 'image', formatValues: null } as EditorToolbarItem,
      { formatName: 'separator', formatValues: null } as EditorToolbarItem,
      { formatName: 'clear', formatValues: null } as EditorToolbarItem,
      { formatName: 'codeBlock', formatValues: null } as EditorToolbarItem,
      { formatName: 'blockquote', formatValues: null } as EditorToolbarItem,
    ];

    if (this.filterToolbarItems) {
      this.toolbarItems = this.filterToolbarItems(this.toolbarItems);
    }
  }

  private prepareInnerLinks(data: string): string {
    const container = document.createElement('div');
    container.innerHTML = data;

    const anchorTags = container.querySelectorAll('a');

    anchorTags.forEach((anchor: HTMLAnchorElement) => {
      if (anchor.id) {
        anchor.href = `^${anchor.id}`;
      }
    });

    return container.innerHTML;
  }

  configureLinks(value: string): string {
    const currentWindowPath = window.location.pathname;
    value = value.replace(/(<a[^>]*href=")(https?:\/\/[^"]+)("[^>]*>)/gi, '$1$2" target="_blank"$3');

    const anchorTags = document.getElementsByTagName('a');

    for (let i = 0; i <= anchorTags.length; i++) {
      const item = anchorTags.item(i);

      if (item && (item.href.includes('%5E') || item.href.includes('about:blank'))) {
        item.id = item.href.split('%5E').pop();
        item.style.color = 'blue';
        item.removeAttribute('href');
      }
    }

    return value.replace(/<a\s+(?:[^>]*?\s+)?href="(#\S*?)"(?:\s+[^>]*)?>/gi, (match, hrefValue) => {
      const newHref = currentWindowPath + hrefValue;
      return match.replace(hrefValue, newHref);
    });
  }
}
